import axios from 'axios';
import { getToken, getTokenWs, getIpAddress } from './Common'
import { getUser, handleLogout } from 'src/utils/Common'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});


instance.interceptors.request.use(
  function (config) {
    let AuthToken = getToken();
    let AuthTokenWs = getTokenWs();
    let IpAddress = getIpAddress();
    let user = getUser();
    config.headers = {
      ...config.headers,
      'Authorization': 'Bearer ' + AuthToken,
      'SessionToken': AuthToken,
      'SessionTokenWs': AuthTokenWs,
      'IpAddress': IpAddress || '',
      'Auth-UserId': user ? user.UserId : ''
    };
    
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    return response;
  }, function (error) {
    if (error.response && error.response.data && error.response.data.error === "401 Unauthorized") {
      alert("Başka bir cihazdan giriş yaptığınız için oturumunuz sonlandırıldı!..");
      handleLogout();
    }
    return Promise.reject(error);
  });

export default instance;
